<template>
  <div class="main-sidebar">
    <el-row class="tac">
      <el-col :span="12">
        <h5>线上图采管理后台</h5>
        <el-menu :default-active="'./HomeSetup'" class="el-menu-vertical">
          <el-submenu v-for="(item,i) in menuList" :key="i" :index="String(i)">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>{{item.title}}</span>
            </template>
            <el-menu-item v-for="(subitem,j) in item.submenu" :key="j" :index="subitem.index"
              @click="routeJump(subitem.index)">{{subitem.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    name: "sidebar",
    data() {
      return {
        menuList: [
          {
            title: "展会信息管理",
            submenu: [
              {
                name: "展会首页",
                index: "HomeSetup",
                router: ""
              },
              {
                name: "展会排程",
                index: "PlanList",
                router: ""
              },
              {
                name: "照片墙",
                index: "PhotoWall",
                router: ""
              }
            ]
          },
          {
            title: "分类信息管理",
            submenu: [
              {
                name: "出版社推荐",
                index: "PublisherSuggest",
                router: ""
              },
              {
                name: "出版社排行",
                index: "PublisherRank",
                router: ""
              },
              {
                name: "书籍排行",
                index: "BookRank",
                router: ""
              },
              {
                name: "书籍推荐",
                index: "BookSuggest",
                router: ""
              },
              {
                name: "周边推荐",
                index: "SurroundSuggest",
                router: ""
              },
              {
                name: "其他品类",
                index: "OtherCategory",
                router: ""
              }
            ]
          },
          {
            title: "直播信息管理",
            submenu: [
              {
                name: "创建直播",
                index: "CreatVhall",
                router: ""
              },
              {
                name: "创建录播",
                index: "creatLubo",
                router: ""
              },
              {
                name: "直播管理",
                index: "Livelist",
                router: ""
              }
            ]
          },
          {
            title: "订单信息管理",
            submenu: [
              {
                name: "查看订单",
                index: "OrderView",
                router: ""
              }
            ]
          },
          {
            title: "直播带货管理",
            submenu: [
              {
                name: "链接配置",
                index: "SetLiveLink",
                router: ""
              }
            ]
          }
        ]
      };
    },
    methods: {
      routeJump(key) {
        if (this.$route.name !== key) {
          this.$router.push({ name: key });
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .el-col-12 {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/SysManager/sidebar.vue